import React, { useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { filesByRawName } from "../../../graphql/queries";

import {
  useNotify,
  FileInput,
  SelectInput,
  TextInput,
  required,
} from "react-admin";
import { useForm } from "react-final-form";

import { Grid } from "@material-ui/core";

import {
  ACCEPTED_FILES,
  FileVisibilityOptions,
  MAX_FILE_SIZE,
  MAX_FILE_SIZE_MSG,
  UserFileVisibility,
  UserType,
} from "../../../utils/constants";
import { logError } from "../../../utils/appUtils";
import { AttachFileIcon } from "../../../components/common/iconography";
import { FileField } from "../../../components/common/FileField";
import { CreateCategory } from "./CreateCategory";

const validateFileUnicity = async (value, record) => {
  debugger;
  if (value && value.path) {
    try {
      let resp = await API.graphql(
        graphqlOperation(filesByRawName, {
          reloadYardId: window.appUser?.reloadYardId,
          rawFileName: { beginsWith: value.path },
        })
      );

      if (
        resp.data.filesByRawName.items.length !== 0 &&
        value.path !== record.rawFileName
      ) {
        // return a validator-like object: { message: 'File %{file} already exists', args: { file: value.rawFile.name } }
        return { message: `File ${value.path} already exists` };
      }
    } catch (error) {
      logError("files:FileSetupTab:validateFileUnicity", error, false);
    }
  }
  return null;
};

const validateRequired = required();

export const FileSetupTab = (props) => {
  const form = useForm();
  const notify = useNotify();
  const [categoryOptions, setCategoryOptions] = useState(
    window.appUser?.reloadYard?.fileCategories || []
  );

  // Subscribe to field state updates for 3rd party inputs
  form.registerField(
    "accountName",
    (fieldState) => {
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true }
  );

  const handleFileChange = async (value) => {
    debugger;
    const nameState = form.getFieldState("displayName");
    const displayName = nameState.value;

    const isDuplicate = await validateFileUnicity(value, props.record);
    if (value?.size > MAX_FILE_SIZE) {
      notify(MAX_FILE_SIZE_MSG, "warning");
      form.change("file", null);
    } else if (isDuplicate) {
      notify(isDuplicate.message, "warning");
      form.change("file", null);
    } else if (!displayName || displayName === "")
      form.change("displayName", value?.name);
  };

  return (
    <Grid container direction="column" spacing={1}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12}>
          <FileInput
            source="file"
            label="UPLOAD FILE"
            variant="outlined"
            fullWidth
            placeholder={
              <p>
                <AttachFileIcon fontSize="large" /> <br /> Drop a File to
                upload, or click to select it.
              </p>
            }
            accept={ACCEPTED_FILES}
            onChange={handleFileChange}
            validate={validateRequired}
          >
            <FileField source="src" title="title" target="_blank" />
          </FileInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            source="displayName"
            label="Display Name"
            variant="outlined"
            fullWidth
            resettable
            validate={validateRequired}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectInput
            source="category"
            label="Document Category"
            variant="outlined"
            fullWidth
            choices={categoryOptions}
            optionValue="key"
            allowEmpty
            createLabel="Add new category..."
            create={<CreateCategory setCategoryOptions={setCategoryOptions} />}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectInput
            source="visibility"
            label="Visible To"
            variant="outlined"
            fullWidth
            choices={FileVisibilityOptions}
            initialValue={UserFileVisibility[UserType.CREW]}
            validate={validateRequired}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            source="description"
            label="Description"
            variant="outlined"
            multiline
            minRows="5"
            fullWidth
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
